export function displayVersion(version: string | null | undefined): string {
  const value = version?.trim();
  if (!value) return "local";
  return /^[0-9a-f]{40}$/i.test(value) ? value.slice(0, 7) : value;
}
